import * as ACTION_TYPES from '../types';

let initialState = {
  locationList: [],
  location: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_LOCATIONS:
      return {...state, locationList: action.data };
    case ACTION_TYPES.DELETE_LOCATION:
      let newList = state.locationList.filter(location => location._id !== action.id);
      return {...state, locationList: newList };
    case ACTION_TYPES.GET_LOCATION_BY_ID:
      return {...state, location: action.data};
    case ACTION_TYPES.GET_LOCATION_BY_CODE:
      return {...state, locationList: action.data};
    case ACTION_TYPES.REQUEST:
      return {...state, loading: true };
    case ACTION_TYPES.DONE:
      return {...state, loading: false };
    case ACTION_TYPES.RESET_LOCATIONS:
      return {...state, locationList: []}
    default:
      return state;
  }
};